import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap'

require('../node_modules/bootstrap/dist/css/bootstrap.min.css')

require('../node_modules/naega-main/src/css/common.css')
require('./css/app.css')

createApp(App).mount('#app')
